'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'laptop';
var width = 640;
var height = 512;
var aliases = [128187];
var unicode = 'f109';
var svgPathData = ['M32.5 400l575.1 0c-3.5 27.1-26.6 48-54.7 48L87.1 448c-28 0-51.2-20.9-54.7-48zM96 96c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 224-448 0 0-224z', 'M512 64L128 64c-17.7 0-32 14.3-32 32l0 224-32 0 0-224c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 224-32 0 0-224c0-17.7-14.3-32-32-32zM87.1 448l465.8 0c28 0 51.2-20.9 54.7-48L32.5 400c3.5 27.1 26.6 48 54.7 48zM0 392.9C0 379.1 11.1 368 24.9 368l590.2 0c13.7 0 24.9 11.1 24.9 24.9 0 48.1-39 87.1-87.1 87.1L87.1 480C39 480 0 441 0 392.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;